export default "__VITE_ASSET__CwO6MGFd__"